<template>
  <div class="container page" style="background-color: #fff;padding-bottom: 20px;">
    <van-nav-bar :title="$t('my.withdraw')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
      <template #right>
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{$t("withdraw.with_record")}}</span>
      </template>
    </van-nav-bar>
	<div style="padding: 0 12px;box-sizing: border-box;padding-top:20px;background: #fff;">
		<div style="margin-top:6px;background: #fff;border-radius:4px;">
			<div style="height:115px;background: linear-gradient(180deg, #fc78af, #f22678);;width: 100%;border-radius:10px;color: #fff !important;padding:20px;">
				<div style="color: #000;margin-top: 14px;font-size: 16px;line-height: 24px;">
					{{$t("auth.top8")}}
				</div>
				<div style="font-size:40px;color: #fff;line-height: 50px;">
					{{ this.userInfo.money }}
				</div>
			</div>
		</div>
		<div style="margin-top:10px;padding: 10px 0;border-radius:10px;background-color: #fff;">
			<div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr;grid-gap: 10px 10px;margin-bottom:10px;">
				<div @click="num(v)" v-for="(v,key) in withdrawRole.custom_money" :key="key" style="text-align: center;padding:8px;border: 1px solid grey;border-radius:6px;font-size:10px;">
					{{v}}
				</div>
			</div>
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;">
				{{$t("my.msg49")}}
			</div>
			<div style="width: 100%;height: 30px;margin-bottom: 5px;margin-top: 5px;">
				<div style="width: 40%;float: left;margin-left: 7%;height: 30px;display: flex; /* 将父容器设置为 Flexbox */
			justify-content: center;
			align-items: center;">
					<div @click="history(1)" :class="class1?'aaitce':''" style="margin: 0 auto;height: 30px;line-height: 30px;font-size: 14px;font-weight: 700;width:100%;background: #d9d9d9;border-radius: 10px;text-align: center;">{{$t("my.msg50")}}</div>
				</div>
				<div style="width: 40%;float: right;margin-right: 7%;height: 30px;display: flex; /* 将父容器设置为 Flexbox */
			justify-content: center;
			align-items: center;">
					<div @click="history(2)" :class="class2?'aaitce':''" style="margin: 0 auto;height: 30px;line-height: 30px;font-size: 14px;font-weight: 700;width:100%;background: #d9d9d9;border-radius: 10px;text-align: center;">{{$t("my.msg51")}}</div>
				</div>
				<div style="clear:both"></div>
			</div>
			<div style="position: relative;display: -webkit-box;display: -webkit-flex;display: -ms-flexbox;display: flex;box-sizing: border-box;width: 100%;padding:10px 16px;overflow: hidden;color: #323233;font-size:14px;line-height:24px;background-color: #fff;">
				<div style="margin-right:4px;">
					<div style="margin-right:10px">
						<img style="width:20px;height:20px" src="/img/home/q.png">
					</div>
				</div>
				<div style="display: flex;-webkit-box-align: center;align-items: center;">
					<van-field type="number" style=";display: block;box-sizing: border-box;width: 80%;min-width: 0;margin: 0;padding: 0;color: #323233;line-height: inherit;text-align: left;background-color: transparent;border: 0;resize: none;" v-model="withdraw_money" :value="this.withdraw_money" :placeholder="$t('my.msg47')"/>
					<div style="background: linear-gradient(180deg, #fc78af, #f22678);padding:3px 15px;margin-right:10px;border-radius: 5px;" @click="allMoeny()">
						<span style="color: #fff;font-size: 16px;text-align: center">All</span>
					</div>
				</div>
			</div>
			<div style="position: relative;display: -webkit-box;display: -webkit-flex;display: -ms-flexbox;display: flex;box-sizing: border-box;width: 100%;padding:10px 16px;overflow: hidden;color: #323233;font-size:14px;line-height:24px;background-color: #fff;">
				<div style="margin-right:4px;">
					<div style="margin-right:10px">
						<img style="width:20px;height:20px" src="/img/home/t.png">
					</div>
				</div>
				<div style="display: flex;-webkit-box-align: center;align-items: center;">
					<van-field type="password" style=";display: block;box-sizing: border-box;width: 80%;min-width: 0;margin: 0;padding: 0;color: #323233;line-height: inherit;text-align: left;background-color: transparent;border: 0;resize: none;" v-model="paypassword" :value="this.paypassword" :placeholder="$t('my.msg48')"/>
				</div>
			</div>
			<div style="margin-top:20px;padding: 0 16px;">
				<p style="color: #ababab;line-height:18px;font-size:12px;">{{$t("my.msg52")}}:{{this.withdrawRole.min}}</p>
				<p style="color: #ababab;line-height:18px;font-size:12px;">{{$t("my.msg53")}}:{{this.withdrawRole.max}}</p>
			</div>
		</div>
		<div style="padding:5px 16px;width:100%">
			<div @click="doWithdraw()" style="border-radius: 10px;;font-size: 16px;;text-align: center;;line-height: 46px;;width: 100%;height:46px;color: white;background: linear-gradient(180deg, #fc78af, #f22678);border-color: rgb(156, 206, 109);">
				{{$t("my.msg54")}}
			</div>
		</div>
	</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPopover: false,
      withdraw_money:"",paypassword:"",type:"",class1:false,class2:false,bank:false,usdt:false,
      userInfo:{},
      withdrawRole:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },history(e){
		if(e==1){
			if(this.bank==false){
				this.$toast(this.$t("my.msg55"));
			}else{
				this.class1=true;
				this.class2=false;
			}
			
		}else{
			if(this.usdt==false){
				this.$toast(this.$t("my.msg56"));
			}else{
				this.class1=false;
				this.class2=true;
			}
		}
		this.type=e;
	},num(e){
		this.withdraw_money=e;
	},
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res=>{
        if(res.code === 200){
          this.withdrawRole = res.data;this.bank=res.data.bank;this.usdt=res.data.usdt;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    allMoeny(){
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw(){
      if(this.withdraw_money <= 0){
        this.$toast(this.$t("setting.correct_money"));
        return false;
      }else {
		if(this.paypassword==''){
			this.$toast(this.$t("my.msg48"));
			return false;
		}
		if(this.type==''){
			this.$toast(this.$t("my.msg49"));
			return false;
		}
        this.$http({
          method: 'post',
          data:{money:this.withdraw_money,type:this.type,paypassword:this.paypassword},
          url: 'user_set_withdraw' 
        }).then(res=>{
          if(res.code === 200){
            location. reload()
            this.$toast(res.msg);
            this.getUserInfo();
            this.getUserWithdrawRole();
          }else if(res.code ===401){
            this.$toast(res.msg);
          }
        })
      }
    },
    withdrawInfo(){
      this.showPopover = true;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 35px;
  line-height: 80px;
}.aaitce{background: linear-gradient(180deg, #fc78af, #f22678) !important;color: #fff;}
.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}.nav-bar{background: linear-gradient(180deg, #fc78af, #f22678);}
.container .main{
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}
.container .main .withdrawMoney{
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}
.container .main .withdrawMoney .money .moneyNumber{
  font-size: 50px;
  display: flex;
  flex-direction: row;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money .all{
  color: #d10404;
}
.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0!important;
}
.container .main .withdrawMoney .information{
  padding-bottom: 30px;
}
.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}
.container .main .withdrawMoney span{
  padding: 10px 0;
}
.container .main .withdrawMoney .information .balance .number{
  color: #d10404;
}
.withdraw_btn {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#e6c3a1,#7e5678);
}
</style>
